// Wave UX-2.4 #24 (2026-05-23) — 약관 / 개인정보 처리방침 모달.
// Login + (후속) Layout footer 에서 호출. 2 탭 (terms / privacy) + 4 locale.
// 본문 placeholder — Kyle 법무 검토 후 실문 교체 의무. termsModalContent* 키만 갱신.
//
// 사용:
//   <TermsModal initialTab="terms" onClose={fn} />
//   <TermsModal initialTab="privacy" onClose={fn} />

import React, { useState, useEffect } from 'react';
import { useT } from '../../i18n/I18nProvider';

function TermsModal(props) {
  var t = useT();
  var [tab, setTab] = useState(props.initialTab || 'terms');

  useEffect(function() {
    function onKey(e) {
      if (e.key === 'Escape') { props.onClose && props.onClose(); }
    }
    window.addEventListener('keydown', onKey);
    return function() { window.removeEventListener('keydown', onKey); };
  }, [props]);

  function tabBtn(key, label) {
    var active = tab === key;
    return (
      <button type="button" onClick={function(){ setTab(key); }}
        style={{
          flex: 1, height: 44, border: 'none',
          background: active ? 'white' : '#f8fafc',
          color: active ? '#1B3A5C' : '#94a3b8',
          fontSize: 14, fontWeight: 700,
          borderBottom: active ? '2px solid #1B3A5C' : '2px solid transparent',
          cursor: 'pointer',
        }}>{label}</button>
    );
  }

  var contentKey = tab === 'privacy' ? 'termsModalContentPrivacy' : 'termsModalContentTerms';
  var titleKey   = tab === 'privacy' ? 'termsModalTitlePrivacy'   : 'termsModalTitleTerms';

  return (
    <div onClick={props.onClose}
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(15,23,42,0.55)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 2000, padding: 16,      }}>
      <div onClick={function(e){ e.stopPropagation(); }}
        style={{
          width: '100%', maxWidth: 520, maxHeight: '85vh',
          background: 'white', borderRadius: 16,
          boxShadow: '0 12px 40px rgba(15,23,42,0.2)',
          display: 'flex', flexDirection: 'column',
          overflow: 'hidden',
        }}>
        {/* header */}
        <div style={{ display: 'flex', alignItems: 'center', padding: '14px 18px', borderBottom: '1px solid #f1f5f9' }}>
          <div style={{ flex: 1, fontSize: 15, fontWeight: 800, color: '#0f172a' }}>{t(titleKey)}</div>
          <button type="button" onClick={props.onClose}
            aria-label={t('termsModalClose')}
            style={{
              width: 32, height: 32, border: 'none',
              background: '#f1f5f9', borderRadius: '50%',
              color: '#64748b', fontSize: 18, fontWeight: 700,
              cursor: 'pointer',
            }}>×</button>
        </div>

        {/* tabs */}
        <div style={{ display: 'flex', borderBottom: '1px solid #f1f5f9' }}>
          {tabBtn('terms', t('termsModalTitleTerms'))}
          {tabBtn('privacy', t('termsModalTitlePrivacy'))}
        </div>

        {/* body — pre-wrap 유지 (locale 본문 줄바꿈 보존) */}
        <div style={{
          flex: 1, overflowY: 'auto', padding: '18px 20px',
          fontSize: 13, color: '#334155', lineHeight: 1.7,
          whiteSpace: 'pre-wrap',
        }}>
          {t(contentKey)}
        </div>
      </div>
    </div>
  );
}

export default TermsModal;
